import { Component, Input } from '@angular/core';
import { ImagesService } from 'app/services/utilities/images.service';
import { PaymentMethodValidatorService } from 'app/services/utilities/payment-method-validator.service';

@Component({
    selector: 'app-display-card-type',
    templateUrl: './display-card-type.component.html',
    styleUrls: ['./display-card-type.component.scss']
})
export class DisplayCardTypeComponent {
    @Input() cardNumber: number;
    @Input() paymentProductId: number;
    @Input() highlight: boolean = true;

    constructor(
        public imgService: ImagesService,
        protected paymentMethodValidator: PaymentMethodValidatorService) { }

    validateBrandName(brand: string): boolean {
        if (this.paymentProductId) {
            let bool: boolean | any = this.paymentMethodValidator.detectCardTypeByPaymentProductId(this.paymentProductId, brand);
            return bool;
        } else {
            let bool: boolean | any = this.paymentMethodValidator.detectCardType(this.cardNumber, brand);
            return bool;
        }
    }
}
